import script from "./HeaderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderModal.vue?vue&type=script&setup=true&lang=js"

import "./HeaderModal.vue?vue&type=style&index=0&id=16952ead&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16952ead"]])

export default __exports__